import styled from '@emotion/styled';
import { css } from '@emotion/react';

import MEDIA_QUERY from '../../../styles/emotion/mediaQuery';

import SPACING from '../../../styles/emotion/spacing';

export const Wrapper = styled.div<{ scrollBody: boolean }>`
  /* Flex + flex column gives us a top to bottom layout, and then we set shrink=0 on the header and controls and overflow-y: auto on the body to get scrolling in the bottom with the controls & header always visible */
  display: flex;
  flex-direction: column;
  padding: ${SPACING.S48};

  ${({ scrollBody }) =>
    scrollBody &&
    css`
      ${MEDIA_QUERY.EXCLUDE_MOBILE_XS} {
        /** Place the modal 40px from top and 40px from bottom (at most) */
        max-height: calc(100vh - 80px);
      }
    `}

  ${MEDIA_QUERY.MOBILE} {
    padding: ${SPACING.S24};
    overflow-y: auto;
  }
`;

export const Body = styled.div<{ scrollBody: boolean }>`
  ${({ scrollBody }) =>
    scrollBody &&
    css`
      overflow-y: auto;
    `}
`;

export const Controls = styled.div<{
  stackedButtons: boolean;
  alignControlsLeft: boolean;
}>`
  display: flex;
  gap: ${SPACING.XS};
  margin-top: ${SPACING.MD};

  /* Flex shrink 0 gives us fixed space for the buttons */
  flex-shrink: 0;

  ${({ alignControlsLeft }) =>
    alignControlsLeft
      ? css`
          justify-content: flex-start;
        `
      : css`
          justify-content: flex-end;
        `};

  ${({ stackedButtons }) =>
    stackedButtons
      ? css`
          /** Stack the buttons vertically and span the width of the modal */
          ${MEDIA_QUERY.MOBILE} {
            flex-direction: column;
            align-items: center;
            gap: ${SPACING.S16};

            button {
              width: 100%;
            }
          }
        `
      : css`
          /* Without stacked buttons, on mobile, push the buttons to the sides of the modal and grow each button */
          ${MEDIA_QUERY.MOBILE} {
            justify-content: space-between;
            button {
              flex-grow: 1;
            }
          }
        `}
`;

export const Title = styled.h1<{ sticky: boolean }>`
  margin-bottom: ${SPACING.MD};
  color: var(--text-primary);

  /* Flex shrink 0 gives us fixed space for the title */
  flex-shrink: 0;

  ${({ sticky }) =>
    sticky
      ? css`
          ${MEDIA_QUERY.MOBILE} {
            margin: -${SPACING.MD} -${SPACING.MD} 0;
            padding: ${SPACING.MD};
            box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
          }
        `
      : undefined};
`;
